export const PILL_TABS_OPTIONS = ["mandatory", "workplaceSpecific"] as const;

export type PillTabOption = (typeof PILL_TABS_OPTIONS)[number];

export interface PillTabSearchParams extends Record<string, unknown> {
  tab: PillTabOption;
}
